export type EarthingCause = {
  cause: string;
  probability: number;
};

export type EarthingFault = {
  id: string;
  category_id: string | null;
  device_ar: string;
  name_ar: string;
  description_ar: string;
  symptoms: string[];
  causes: EarthingCause[];
  tests: {
    test: string;
    location: string;
    method: string;
    normal: string;
    faulty: string;
  }[];
  solutions: string[];
  severity: string;
  safety_warnings: string[];
  error_code: string | null;
  keywords: string;
  next_question_key: string | null;
};

type Row = [
  string,
  string,
  string,
  string,
  string,
  EarthingCause[],
  string[],
  string,
  string
];

const C = (cause: string, probability: number): EarthingCause => ({
  cause,
  probability,
});

const rows: Row[] = [
[
  "earthing-001",
  "قضيب التأريض",
  "قضيب التأريض ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة قضيب التأريض متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة قضيب التأريض",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "التأريض Earthing earth rod not working open",
],
[
  "earthing-002",
  "قضيب التأريض",
  "حرارة قضيب التأريض ترتفع",
  "حرارة قضيب التأريض أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة قضيب التأريض",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "التأريض Earthing earth rod overheating hot",
],
[
  "earthing-003",
  "قضيب التأريض",
  "قضيب التأريض يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة قضيب التأريض تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "التأريض Earthing earth rod intermittent unstable",
],
[
  "earthing-004",
  "قضيب التأريض",
  "قضيب التأريض بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ قضيب التأريض.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "التأريض Earthing earth rod loose wrong connection",
],
[
  "earthing-005",
  "قضيب التأريض",
  "قراءة أو خرج قضيب التأريض مو طبيعي",
  "قراءة أو خرج قضيب التأريض أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "التأريض Earthing earth rod abnormal reading output",
],
[
  "earthing-006",
  "شبكة التأريض",
  "شبكة التأريض ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة شبكة التأريض متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة شبكة التأريض",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "التأريض Earthing ground grid not working open",
],
[
  "earthing-007",
  "شبكة التأريض",
  "حرارة شبكة التأريض ترتفع",
  "حرارة شبكة التأريض أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة شبكة التأريض",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "التأريض Earthing ground grid overheating hot",
],
[
  "earthing-008",
  "شبكة التأريض",
  "شبكة التأريض يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة شبكة التأريض تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "التأريض Earthing ground grid intermittent unstable",
],
[
  "earthing-009",
  "شبكة التأريض",
  "شبكة التأريض بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ شبكة التأريض.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "التأريض Earthing ground grid loose wrong connection",
],
[
  "earthing-010",
  "شبكة التأريض",
  "قراءة أو خرج شبكة التأريض مو طبيعي",
  "قراءة أو خرج شبكة التأريض أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "التأريض Earthing ground grid abnormal reading output",
],
[
  "earthing-011",
  "سلك التأريض الرئيسي",
  "سلك التأريض الرئيسي ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة سلك التأريض الرئيسي متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة سلك التأريض الرئيسي",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "التأريض Earthing grounding conductor not working open",
],
[
  "earthing-012",
  "سلك التأريض الرئيسي",
  "حرارة سلك التأريض الرئيسي ترتفع",
  "حرارة سلك التأريض الرئيسي أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة سلك التأريض الرئيسي",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "التأريض Earthing grounding conductor overheating hot",
],
[
  "earthing-013",
  "سلك التأريض الرئيسي",
  "سلك التأريض الرئيسي يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة سلك التأريض الرئيسي تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "التأريض Earthing grounding conductor intermittent unstable",
],
[
  "earthing-014",
  "سلك التأريض الرئيسي",
  "سلك التأريض الرئيسي بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ سلك التأريض الرئيسي.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "التأريض Earthing grounding conductor loose wrong connection",
],
[
  "earthing-015",
  "سلك التأريض الرئيسي",
  "قراءة أو خرج سلك التأريض الرئيسي مو طبيعي",
  "قراءة أو خرج سلك التأريض الرئيسي أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "التأريض Earthing grounding conductor abnormal reading output",
],
[
  "earthing-016",
  "بار التأريض الرئيسي",
  "بار التأريض الرئيسي ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة بار التأريض الرئيسي متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة بار التأريض الرئيسي",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "التأريض Earthing earth bar not working open",
],
[
  "earthing-017",
  "بار التأريض الرئيسي",
  "حرارة بار التأريض الرئيسي ترتفع",
  "حرارة بار التأريض الرئيسي أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة بار التأريض الرئيسي",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "التأريض Earthing earth bar overheating hot",
],
[
  "earthing-018",
  "بار التأريض الرئيسي",
  "بار التأريض الرئيسي يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة بار التأريض الرئيسي تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "التأريض Earthing earth bar intermittent unstable",
],
[
  "earthing-019",
  "بار التأريض الرئيسي",
  "بار التأريض الرئيسي بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ بار التأريض الرئيسي.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "التأريض Earthing earth bar loose wrong connection",
],
[
  "earthing-020",
  "بار التأريض الرئيسي",
  "قراءة أو خرج بار التأريض الرئيسي مو طبيعي",
  "قراءة أو خرج بار التأريض الرئيسي أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "التأريض Earthing earth bar abnormal reading output",
],
[
  "earthing-021",
  "ربط جسم اللوحة بالأرضي",
  "ربط جسم اللوحة بالأرضي ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة ربط جسم اللوحة بالأرضي متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة ربط جسم اللوحة بالأرضي",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "التأريض Earthing panel bonding not working open",
],
[
  "earthing-022",
  "ربط جسم اللوحة بالأرضي",
  "حرارة ربط جسم اللوحة بالأرضي ترتفع",
  "حرارة ربط جسم اللوحة بالأرضي أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة ربط جسم اللوحة بالأرضي",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "التأريض Earthing panel bonding overheating hot",
],
[
  "earthing-023",
  "ربط جسم اللوحة بالأرضي",
  "ربط جسم اللوحة بالأرضي يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة ربط جسم اللوحة بالأرضي تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "التأريض Earthing panel bonding intermittent unstable",
],
[
  "earthing-024",
  "ربط جسم اللوحة بالأرضي",
  "ربط جسم اللوحة بالأرضي بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ ربط جسم اللوحة بالأرضي.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "التأريض Earthing panel bonding loose wrong connection",
],
[
  "earthing-025",
  "ربط جسم اللوحة بالأرضي",
  "قراءة أو خرج ربط جسم اللوحة بالأرضي مو طبيعي",
  "قراءة أو خرج ربط جسم اللوحة بالأرضي أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "التأريض Earthing panel bonding abnormal reading output",
],
[
  "earthing-026",
  "ربط المحرك بالأرضي",
  "ربط المحرك بالأرضي ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة ربط المحرك بالأرضي متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة ربط المحرك بالأرضي",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "التأريض Earthing motor grounding not working open",
],
[
  "earthing-027",
  "ربط المحرك بالأرضي",
  "حرارة ربط المحرك بالأرضي ترتفع",
  "حرارة ربط المحرك بالأرضي أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة ربط المحرك بالأرضي",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "التأريض Earthing motor grounding overheating hot",
],
[
  "earthing-028",
  "ربط المحرك بالأرضي",
  "ربط المحرك بالأرضي يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة ربط المحرك بالأرضي تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "التأريض Earthing motor grounding intermittent unstable",
],
[
  "earthing-029",
  "ربط المحرك بالأرضي",
  "ربط المحرك بالأرضي بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ ربط المحرك بالأرضي.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "التأريض Earthing motor grounding loose wrong connection",
],
[
  "earthing-030",
  "ربط المحرك بالأرضي",
  "قراءة أو خرج ربط المحرك بالأرضي مو طبيعي",
  "قراءة أو خرج ربط المحرك بالأرضي أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "التأريض Earthing motor grounding abnormal reading output",
],
[
  "earthing-031",
  "ربط المحولة بالأرضي",
  "ربط المحولة بالأرضي ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة ربط المحولة بالأرضي متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة ربط المحولة بالأرضي",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "التأريض Earthing transformer grounding not working open",
],
[
  "earthing-032",
  "ربط المحولة بالأرضي",
  "حرارة ربط المحولة بالأرضي ترتفع",
  "حرارة ربط المحولة بالأرضي أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة ربط المحولة بالأرضي",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "التأريض Earthing transformer grounding overheating hot",
],
[
  "earthing-033",
  "ربط المحولة بالأرضي",
  "ربط المحولة بالأرضي يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة ربط المحولة بالأرضي تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "التأريض Earthing transformer grounding intermittent unstable",
],
[
  "earthing-034",
  "ربط المحولة بالأرضي",
  "ربط المحولة بالأرضي بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ ربط المحولة بالأرضي.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "التأريض Earthing transformer grounding loose wrong connection",
],
[
  "earthing-035",
  "ربط المحولة بالأرضي",
  "قراءة أو خرج ربط المحولة بالأرضي مو طبيعي",
  "قراءة أو خرج ربط المحولة بالأرضي أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "التأريض Earthing transformer grounding abnormal reading output",
],
[
  "earthing-036",
  "ربط المولد بالأرضي",
  "ربط المولد بالأرضي ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة ربط المولد بالأرضي متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة ربط المولد بالأرضي",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "التأريض Earthing generator grounding not working open",
],
[
  "earthing-037",
  "ربط المولد بالأرضي",
  "حرارة ربط المولد بالأرضي ترتفع",
  "حرارة ربط المولد بالأرضي أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة ربط المولد بالأرضي",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "التأريض Earthing generator grounding overheating hot",
],
[
  "earthing-038",
  "ربط المولد بالأرضي",
  "ربط المولد بالأرضي يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة ربط المولد بالأرضي تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "التأريض Earthing generator grounding intermittent unstable",
],
[
  "earthing-039",
  "ربط المولد بالأرضي",
  "ربط المولد بالأرضي بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ ربط المولد بالأرضي.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "التأريض Earthing generator grounding loose wrong connection",
],
[
  "earthing-040",
  "ربط المولد بالأرضي",
  "قراءة أو خرج ربط المولد بالأرضي مو طبيعي",
  "قراءة أو خرج ربط المولد بالأرضي أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "التأريض Earthing generator grounding abnormal reading output",
],
[
  "earthing-041",
  "ربط الهياكل المعدنية",
  "ربط الهياكل المعدنية ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة ربط الهياكل المعدنية متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة ربط الهياكل المعدنية",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "التأريض Earthing structure bonding not working open",
],
[
  "earthing-042",
  "ربط الهياكل المعدنية",
  "حرارة ربط الهياكل المعدنية ترتفع",
  "حرارة ربط الهياكل المعدنية أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة ربط الهياكل المعدنية",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "التأريض Earthing structure bonding overheating hot",
],
[
  "earthing-043",
  "ربط الهياكل المعدنية",
  "ربط الهياكل المعدنية يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة ربط الهياكل المعدنية تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "التأريض Earthing structure bonding intermittent unstable",
],
[
  "earthing-044",
  "ربط الهياكل المعدنية",
  "ربط الهياكل المعدنية بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ ربط الهياكل المعدنية.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "التأريض Earthing structure bonding loose wrong connection",
],
[
  "earthing-045",
  "ربط الهياكل المعدنية",
  "قراءة أو خرج ربط الهياكل المعدنية مو طبيعي",
  "قراءة أو خرج ربط الهياكل المعدنية أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "التأريض Earthing structure bonding abnormal reading output",
],
[
  "earthing-046",
  "Neutral-Earth Bond حسب التصميم",
  "Neutral-Earth Bond حسب التصميم ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة Neutral-Earth Bond حسب التصميم متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة Neutral-Earth Bond حسب التصميم",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "التأريض Earthing neutral earth bond not working open",
],
[
  "earthing-047",
  "Neutral-Earth Bond حسب التصميم",
  "حرارة Neutral-Earth Bond حسب التصميم ترتفع",
  "حرارة Neutral-Earth Bond حسب التصميم أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة Neutral-Earth Bond حسب التصميم",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "التأريض Earthing neutral earth bond overheating hot",
],
[
  "earthing-048",
  "Neutral-Earth Bond حسب التصميم",
  "Neutral-Earth Bond حسب التصميم يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة Neutral-Earth Bond حسب التصميم تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "التأريض Earthing neutral earth bond intermittent unstable",
],
[
  "earthing-049",
  "Neutral-Earth Bond حسب التصميم",
  "Neutral-Earth Bond حسب التصميم بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ Neutral-Earth Bond حسب التصميم.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "التأريض Earthing neutral earth bond loose wrong connection",
],
[
  "earthing-050",
  "Neutral-Earth Bond حسب التصميم",
  "قراءة أو خرج Neutral-Earth Bond حسب التصميم مو طبيعي",
  "قراءة أو خرج Neutral-Earth Bond حسب التصميم أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "التأريض Earthing neutral earth bond abnormal reading output",
],
[
  "earthing-051",
  "Earth Pit",
  "Earth Pit ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة Earth Pit متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة Earth Pit",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "التأريض Earthing earth pit not working open",
],
[
  "earthing-052",
  "Earth Pit",
  "حرارة Earth Pit ترتفع",
  "حرارة Earth Pit أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة Earth Pit",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "التأريض Earthing earth pit overheating hot",
],
[
  "earthing-053",
  "Earth Pit",
  "Earth Pit يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة Earth Pit تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "التأريض Earthing earth pit intermittent unstable",
],
[
  "earthing-054",
  "Earth Pit",
  "Earth Pit بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ Earth Pit.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "التأريض Earthing earth pit loose wrong connection",
],
[
  "earthing-055",
  "Earth Pit",
  "قراءة أو خرج Earth Pit مو طبيعي",
  "قراءة أو خرج Earth Pit أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "التأريض Earthing earth pit abnormal reading output",
],
[
  "earthing-056",
  "Earth Clamp",
  "Earth Clamp ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة Earth Clamp متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة Earth Clamp",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "التأريض Earthing earth clamp not working open",
],
[
  "earthing-057",
  "Earth Clamp",
  "حرارة Earth Clamp ترتفع",
  "حرارة Earth Clamp أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة Earth Clamp",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "التأريض Earthing earth clamp overheating hot",
],
[
  "earthing-058",
  "Earth Clamp",
  "Earth Clamp يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة Earth Clamp تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "التأريض Earthing earth clamp intermittent unstable",
],
[
  "earthing-059",
  "Earth Clamp",
  "Earth Clamp بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ Earth Clamp.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "التأريض Earthing earth clamp loose wrong connection",
],
[
  "earthing-060",
  "Earth Clamp",
  "قراءة أو خرج Earth Clamp مو طبيعي",
  "قراءة أو خرج Earth Clamp أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "التأريض Earthing earth clamp abnormal reading output",
],
[
  "earthing-061",
  "Exothermic Weld",
  "Exothermic Weld ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة Exothermic Weld متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة Exothermic Weld",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "التأريض Earthing cadweld not working open",
],
[
  "earthing-062",
  "Exothermic Weld",
  "حرارة Exothermic Weld ترتفع",
  "حرارة Exothermic Weld أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة Exothermic Weld",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "التأريض Earthing cadweld overheating hot",
],
[
  "earthing-063",
  "Exothermic Weld",
  "Exothermic Weld يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة Exothermic Weld تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "التأريض Earthing cadweld intermittent unstable",
],
[
  "earthing-064",
  "Exothermic Weld",
  "Exothermic Weld بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ Exothermic Weld.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "التأريض Earthing cadweld loose wrong connection",
],
[
  "earthing-065",
  "Exothermic Weld",
  "قراءة أو خرج Exothermic Weld مو طبيعي",
  "قراءة أو خرج Exothermic Weld أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "التأريض Earthing cadweld abnormal reading output",
],
[
  "earthing-066",
  "تأريض مانع الصواعق",
  "تأريض مانع الصواعق ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة تأريض مانع الصواعق متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة تأريض مانع الصواعق",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "التأريض Earthing lightning grounding not working open",
],
[
  "earthing-067",
  "تأريض مانع الصواعق",
  "حرارة تأريض مانع الصواعق ترتفع",
  "حرارة تأريض مانع الصواعق أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة تأريض مانع الصواعق",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "التأريض Earthing lightning grounding overheating hot",
],
[
  "earthing-068",
  "تأريض مانع الصواعق",
  "تأريض مانع الصواعق يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة تأريض مانع الصواعق تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "التأريض Earthing lightning grounding intermittent unstable",
],
[
  "earthing-069",
  "تأريض مانع الصواعق",
  "تأريض مانع الصواعق بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ تأريض مانع الصواعق.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "التأريض Earthing lightning grounding loose wrong connection",
],
[
  "earthing-070",
  "تأريض مانع الصواعق",
  "قراءة أو خرج تأريض مانع الصواعق مو طبيعي",
  "قراءة أو خرج تأريض مانع الصواعق أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "التأريض Earthing lightning grounding abnormal reading output",
],
[
  "earthing-071",
  "SPD Grounding",
  "SPD Grounding ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة SPD Grounding متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة SPD Grounding",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "التأريض Earthing spd grounding not working open",
],
[
  "earthing-072",
  "SPD Grounding",
  "حرارة SPD Grounding ترتفع",
  "حرارة SPD Grounding أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة SPD Grounding",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "التأريض Earthing spd grounding overheating hot",
],
[
  "earthing-073",
  "SPD Grounding",
  "SPD Grounding يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة SPD Grounding تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "التأريض Earthing spd grounding intermittent unstable",
],
[
  "earthing-074",
  "SPD Grounding",
  "SPD Grounding بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ SPD Grounding.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "التأريض Earthing spd grounding loose wrong connection",
],
[
  "earthing-075",
  "SPD Grounding",
  "قراءة أو خرج SPD Grounding مو طبيعي",
  "قراءة أو خرج SPD Grounding أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "التأريض Earthing spd grounding abnormal reading output",
],
[
  "earthing-076",
  "Shield Ground",
  "Shield Ground ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة Shield Ground متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة Shield Ground",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "التأريض Earthing shield grounding not working open",
],
[
  "earthing-077",
  "Shield Ground",
  "حرارة Shield Ground ترتفع",
  "حرارة Shield Ground أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة Shield Ground",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "التأريض Earthing shield grounding overheating hot",
],
[
  "earthing-078",
  "Shield Ground",
  "Shield Ground يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة Shield Ground تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "التأريض Earthing shield grounding intermittent unstable",
],
[
  "earthing-079",
  "Shield Ground",
  "Shield Ground بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ Shield Ground.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "التأريض Earthing shield grounding loose wrong connection",
],
[
  "earthing-080",
  "Shield Ground",
  "قراءة أو خرج Shield Ground مو طبيعي",
  "قراءة أو خرج Shield Ground أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "التأريض Earthing shield grounding abnormal reading output",
],
[
  "earthing-081",
  "Instrument Ground",
  "Instrument Ground ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة Instrument Ground متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة Instrument Ground",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "التأريض Earthing instrument grounding not working open",
],
[
  "earthing-082",
  "Instrument Ground",
  "حرارة Instrument Ground ترتفع",
  "حرارة Instrument Ground أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة Instrument Ground",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "التأريض Earthing instrument grounding overheating hot",
],
[
  "earthing-083",
  "Instrument Ground",
  "Instrument Ground يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة Instrument Ground تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "التأريض Earthing instrument grounding intermittent unstable",
],
[
  "earthing-084",
  "Instrument Ground",
  "Instrument Ground بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ Instrument Ground.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "التأريض Earthing instrument grounding loose wrong connection",
],
[
  "earthing-085",
  "Instrument Ground",
  "قراءة أو خرج Instrument Ground مو طبيعي",
  "قراءة أو خرج Instrument Ground أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "التأريض Earthing instrument grounding abnormal reading output",
],
[
  "earthing-086",
  "VFD EMC Ground",
  "VFD EMC Ground ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة VFD EMC Ground متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة VFD EMC Ground",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "التأريض Earthing vfd grounding not working open",
],
[
  "earthing-087",
  "VFD EMC Ground",
  "حرارة VFD EMC Ground ترتفع",
  "حرارة VFD EMC Ground أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة VFD EMC Ground",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "التأريض Earthing vfd grounding overheating hot",
],
[
  "earthing-088",
  "VFD EMC Ground",
  "VFD EMC Ground يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة VFD EMC Ground تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "التأريض Earthing vfd grounding intermittent unstable",
],
[
  "earthing-089",
  "VFD EMC Ground",
  "VFD EMC Ground بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ VFD EMC Ground.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "التأريض Earthing vfd grounding loose wrong connection",
],
[
  "earthing-090",
  "VFD EMC Ground",
  "قراءة أو خرج VFD EMC Ground مو طبيعي",
  "قراءة أو خرج VFD EMC Ground أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "التأريض Earthing vfd grounding abnormal reading output",
],
[
  "earthing-091",
  "موصل PE",
  "موصل PE ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة موصل PE متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة موصل PE",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "التأريض Earthing protective earth not working open",
],
[
  "earthing-092",
  "موصل PE",
  "حرارة موصل PE ترتفع",
  "حرارة موصل PE أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة موصل PE",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "التأريض Earthing protective earth overheating hot",
],
[
  "earthing-093",
  "موصل PE",
  "موصل PE يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة موصل PE تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "التأريض Earthing protective earth intermittent unstable",
],
[
  "earthing-094",
  "موصل PE",
  "موصل PE بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ موصل PE.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "التأريض Earthing protective earth loose wrong connection",
],
[
  "earthing-095",
  "موصل PE",
  "قراءة أو خرج موصل PE مو طبيعي",
  "قراءة أو خرج موصل PE أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "التأريض Earthing protective earth abnormal reading output",
],
[
  "earthing-096",
  "مقاومة منظومة التأريض",
  "مقاومة منظومة التأريض ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة مقاومة منظومة التأريض متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة مقاومة منظومة التأريض",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "التأريض Earthing earth resistance not working open",
],
[
  "earthing-097",
  "مقاومة منظومة التأريض",
  "حرارة مقاومة منظومة التأريض ترتفع",
  "حرارة مقاومة منظومة التأريض أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة مقاومة منظومة التأريض",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "التأريض Earthing earth resistance overheating hot",
],
[
  "earthing-098",
  "مقاومة منظومة التأريض",
  "مقاومة منظومة التأريض يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة مقاومة منظومة التأريض تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "التأريض Earthing earth resistance intermittent unstable",
],
[
  "earthing-099",
  "مقاومة منظومة التأريض",
  "مقاومة منظومة التأريض بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ مقاومة منظومة التأريض.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "التأريض Earthing earth resistance loose wrong connection",
],
[
  "earthing-100",
  "مقاومة منظومة التأريض",
  "قراءة أو خرج مقاومة منظومة التأريض مو طبيعي",
  "قراءة أو خرج مقاومة منظومة التأريض أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("تآكل أو أكسدة بنقاط الربط", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "التأريض Earthing earth resistance abnormal reading output",
],
];

export const earthingFaults: EarthingFault[] = rows.map(
  ([
    id,
    device_ar,
    name_ar,
    description_ar,
    symptom,
    causes,
    solutions,
    severity,
    keywords,
  ]) => {
    const critical = severity === "حرجة";

    return {
      id,
      category_id: null,
      device_ar,
      name_ar,
      description_ar,
      symptoms: [symptom],
      causes,
      tests: [
        {
          test: "الفحص الأولي",
          location: device_ar,
          method: "لا تفصل موصل PE أو bonding عن معدات حية. أي قياس يتطلب فصل شبكة الأرضي أو العمل قرب القدرة خليه لفني مؤهل وبإجراء آمن.",
          normal:
            "القراءات والحرارة والتوصيلات ضمن الطبيعي، وماكو حرك أو تسريب أو تقطيع أو تلف واضح.",
          faulty:
            "حرارة عالية أو فصل متكرر أو ربط مرخي أو قراءة غير طبيعية يدل على عطل يحتاج فحص قبل التشغيل.",
        },
      ],
      solutions,
      severity,
      safety_warnings: critical
        ? [
            "تنبيه: اعزل كل مصادر الطاقة قبل الصيانة وانتبه من التغذية الراجعة أو التشغيل الأوتوماتيكي.",
            "العمل أو القياس على أجزاء حية أو جهد عالي خليه لفني مؤهل وبمعدات مناسبة.",
          ]
        : [
            "افصل وعزل التغذية قبل الفك أو إعادة الربط.",
            "إذا شفت شرر أو ذوبان أو ريحة حرك أو تشغيل غير متوقع، وقف المعدة وخلي فني يفحصها.",
          ],
      error_code: null,
      keywords,
      next_question_key: null,
    };
  },
);
